import React, { Component } from "react";
import { Link } from "react-router-dom";

class ApprovalPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "All",
      selectedApprovalId: "TR-2023-0018",
      actionModal: null,
    };
  }

  renderStatus(status) {
    const map = {
      "Pending Approval": ["#FFF7E6", "#B76E00"],
      Approved: ["#ECFDF3", "#027A48"],
      Rejected: ["#FEECEC", "#B42318"],
      Returned: ["#EEF4FF", "#1464E9"],
    };

    const [bg, color] = map[status] || map["Pending Approval"];

    return (
      <span style={{ background: bg, color, padding: "5px 10px", borderRadius: 20, fontSize: 12, fontWeight: 900 }}>
        {status}
      </span>
    );
  }

  renderInfo(label, value) {
    return (
      <div style={{ marginBottom: 16 }}>
        <div style={infoLabel}>{label}</div>
        <div style={infoValue}>{value}</div>
      </div>
    );
  }

  renderModal() {
    if (!this.state.actionModal) return null;

    return (
      <div style={modalOverlay}>
        <div style={modalBox}>
          <h4 style={{ margin: 0, fontWeight: 900 }}>Review Approval</h4>
          <p style={{ color: "#64748B", fontSize: 13 }}>
            Add your comment before confirming the action.
          </p>

          <textarea placeholder="Add comment..." style={textareaStyle} />

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
            <button style={secondaryButton} onClick={() => this.setState({ actionModal: null })}>
              Cancel
            </button>
            <button style={primaryButton} onClick={() => this.setState({ actionModal: null })}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const approvals = [
      ["TR-2023-0018", "Travel Request", "Allistair Lorenzo James", "Houston, USA", "RM 22,480.00", "Pending Approval", "Corporate Strategy"],
      ["CLM-2024-0187", "Claim", "Lee Min Hao", "Local Travel Claim", "RM 1,250.00", "Pending Approval", "Operations"],
      ["TRN-2025-0012", "Training Request", "Ahmad Ridhwan", "Digital Marketing Masterclass", "RM 1,800.00", "Pending Approval", "Finance"],
      ["CLM-2024-0186", "Claim", "Nurul Izzati Binti Rahman", "Credit Card Claim", "RM 2,890.45", "Returned", "Human Resources"],
      ["TR-2023-0015", "Travel Request", "Diana Wong Siew Mei", "Finance Workshop", "RM 680.00", "Approved", "Finance"],
    ];

    const filteredApprovals =
      this.state.activeTab === "All"
        ? approvals
        : approvals.filter((item) => item[1] === this.state.activeTab);

    const selectedApproval =
      approvals.find((item) => item[0] === this.state.selectedApprovalId) || approvals[0];

    return (
      <div style={{ padding: 24 }}>
        <h3 style={{ margin: 0, color: "#0F172A", fontWeight: 900 }}>Approvals</h3>
        <p style={{ margin: "6px 0 22px", color: "#64748B", fontSize: 13 }}>
          Review and take action on Travel, Claim, and Training approval requests.
        </p>

        <div style={summaryGrid}>
          {this.summaryCard("Pending My Approval", 12, "#FFF7E6")}
          {this.summaryCard("Approved This Month", 28, "#ECFDF3")}
          {this.summaryCard("Returned / Revision", 4, "#EEF4FF")}
          {this.summaryCard("Rejected", 3, "#FEECEC")}
        </div>

        <div style={layout}>
          <div style={tableCard}>
            <div style={tabs}>
              {["All", "Travel Request", "Claim", "Training Request"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => this.setState({ activeTab: tab })}
                  style={{
                    ...tabButton,
                    color: this.state.activeTab === tab ? "#DC111C" : "#475569",
                    borderBottom: this.state.activeTab === tab ? "2px solid #DC111C" : "2px solid transparent",
                  }}
                >
                  {tab}
                </button>
              ))}
            </div>

            <div style={filterGrid}>
              <input placeholder="Search request ID, employee, purpose..." style={inputStyle} />
              <select style={inputStyle}><option>All Statuses</option></select>
              <select style={inputStyle}><option>All Departments</option></select>
              <button style={secondaryButton}>Filters</button>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#F8FAFC" }}>
                  {["Request ID", "Type", "Requester", "Description", "Amount", "Status", "Action"].map((h) => (
                    <th key={h} style={thStyle}>{h}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredApprovals.map((row) => (
                  <tr
                    key={row[0]}
                    onClick={() => this.setState({ selectedApprovalId: row[0] })}
                    style={{
                      borderTop: "1px solid #E5E7EB",
                      background: this.state.selectedApprovalId === row[0] ? "#EEF4FF" : "#fff",
                      cursor: "pointer",
                    }}
                  >
                    <td style={tdStyle}>
                      <Link
                        to={
                          row[1] === "Claim"
                            ? `/claim/${row[0]}`
                            : row[1] === "Training Request"
                            ? `/training/request/${row[0]}`
                            : `/travel/${row[0]}`
                        }
                        style={{ color: "#1464E9", fontWeight: 900, textDecoration: "none" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {row[0]}
                      </Link>
                    </td>
                    <td style={tdStyle}>{row[1]}</td>
                    <td style={tdStyle}>{row[2]}</td>
                    <td style={tdStyle}>{row[3]}</td>
                    <td style={tdStyle}>{row[4]}</td>
                    <td style={tdStyle}>{this.renderStatus(row[5])}</td>
                    <td style={tdStyle}>
                      <button
                        style={smallPrimaryButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({
                            selectedApprovalId: row[0],
                            actionModal: "review",
                          });
                        }}
                      >
                        Review
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div style={{ padding: 16, color: "#64748B", fontSize: 12 }}>
              Showing 1 to {filteredApprovals.length} of {filteredApprovals.length} approval requests
            </div>
          </div>

          <div>
            <div style={sideCard}>
              <h4 style={sideTitle}>Selected Approval</h4>
              {this.renderInfo("Request ID", selectedApproval[0])}
              {this.renderInfo("Type", selectedApproval[1])}
              {this.renderInfo("Requester", selectedApproval[2])}
              {this.renderInfo("Department", selectedApproval[6])}
              {this.renderInfo("Amount", selectedApproval[4])}
              {this.renderInfo("Status", this.renderStatus(selectedApproval[5]))}
            </div>

            <div style={sideCard}>
              <h4 style={sideTitle}>Approval Workflow</h4>
              {this.timeline("Submitted", selectedApproval[2], "16 Mar 2023, 10:42 AM", true)}
              {this.timeline("Manager Approval", "Dylan Redas Noel", "Pending action", false)}
              {this.timeline("Next Stage", selectedApproval[1] === "Claim" ? "Finance Team" : "Admin Team", "-", false)}
            </div>

            <div style={sideCard}>
              <h4 style={sideTitle}>Approval Action</h4>
              <textarea placeholder="Add approval comment..." style={textareaStyle} />

              <div style={{ display: "grid", gap: 10, marginTop: 12 }}>
                <button style={{ ...primaryButton, background: "#16A34A" }}>Approve</button>
                <button style={{ ...primaryButton, background: "#F59E0B" }}>Return for Revision</button>
                <button style={{ ...primaryButton, background: "#DC2626" }}>Reject</button>
              </div>
            </div>
          </div>
        </div>

        {this.renderModal()}
      </div>
    );
  }

  summaryCard(label, value, color) {
    return (
      <div style={summaryCard}>
        <div style={{ width: 46, height: 46, borderRadius: 12, background: color }} />
        <div>
          <div style={{ fontSize: 12, color: "#64748B", fontWeight: 900 }}>{label}</div>
          <div style={{ fontSize: 26, fontWeight: 900, color: "#0F172A" }}>{value}</div>
        </div>
      </div>
    );
  }

  timeline(title, by, time, done) {
    return (
      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
        <div
          style={{
            width: 26,
            height: 26,
            borderRadius: "50%",
            background: done ? "#16A34A" : "#1464E9",
            color: "#fff",
            textAlign: "center",
            lineHeight: "26px",
            fontSize: 12,
            fontWeight: 900,
          }}
        >
          {done ? "✓" : "!"}
        </div>
        <div>
          <div style={{ fontWeight: 900, color: "#0F172A" }}>{title}</div>
          <div style={{ color: "#64748B", fontSize: 12 }}>{by}</div>
          <div style={{ color: "#94A3B8", fontSize: 11 }}>{time}</div>
        </div>
      </div>
    );
  }
}

const summaryGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: 16,
  marginBottom: 20,
};

const summaryCard = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  display: "flex",
  alignItems: "center",
  gap: 16,
};

const layout = {
  display: "grid",
  gridTemplateColumns: "1fr 360px",
  gap: 18,
};

const tableCard = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  overflow: "hidden",
};

const tabs = {
  display: "flex",
  gap: 24,
  padding: "16px 18px 0",
  borderBottom: "1px solid #E5E7EB",
};

const tabButton = {
  background: "transparent",
  border: 0,
  padding: "0 0 12px",
  fontSize: 13,
  fontWeight: 900,
  cursor: "pointer",
};

const filterGrid = {
  display: "grid",
  gridTemplateColumns: "2fr 1fr 1fr auto",
  gap: 12,
  padding: 16,
};

const inputStyle = {
  height: 38,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
};

const thStyle = {
  padding: "12px 14px",
  textAlign: "left",
  fontWeight: 900,
  color: "#334155",
  fontSize: 12,
};

const tdStyle = {
  padding: 14,
  color: "#334155",
  fontSize: 13,
};

const sideCard = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginBottom: 16,
};

const sideTitle = {
  margin: "0 0 18px",
  color: "#0F172A",
  fontWeight: 900,
};

const infoLabel = {
  fontSize: 12,
  color: "#64748B",
  fontWeight: 900,
};

const infoValue = {
  fontSize: 13,
  color: "#0F172A",
  fontWeight: 900,
  marginTop: 4,
};

const textareaStyle = {
  width: "100%",
  minHeight: 100,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: 12,
  fontSize: 13,
};

const primaryButton = {
  background: "#1464E9",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "10px 14px",
  fontWeight: 900,
  cursor: "pointer",
};

const smallPrimaryButton = {
  ...primaryButton,
  padding: "7px 12px",
  fontSize: 12,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 14px",
  fontWeight: 800,
};

const modalOverlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(15, 23, 42, 0.45)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modalBox = {
  background: "#fff",
  borderRadius: 14,
  padding: 22,
  width: 460,
};

export default ApprovalPage;